import React from "react";
import { StyledTable } from "./style.js";
import PropTypes from "prop-types";

export default class Table extends React.Component {
  render() {
    return (
      <StyledTable>
        <table className={this.props.paddedRows ? "" : "skinny-rows"}>
          <thead>
            <tr>
              {this.props.columns.map((column, index) => (
                <th key={`${column}-${index}`}>{column}</th>
              ))}
            </tr>
          </thead>
          <tbody>{this.props.children}</tbody>
        </table>
      </StyledTable>
    );
  }
}
Table.propTypes = {
  paddedRows: PropTypes.bool,
  columns: PropTypes.array.isRequired,
  children: PropTypes.any,
};
Table.defaultProps = {
  paddedRows: true,
  columns: [],
  children: null,
};



// WEBPACK FOOTER //
// ./src/components/Table/index.jsx